import React, { useState } from 'react';
import DateRangeSelector from '../../../components/DateRangeSelector';
import InlineMessage from '../../../components/InlineMessage';
import { usePhotoOrdersReportFilters } from './FiltersContext';
import './DateRanges.scss';

const SingleDateRangeFilter = () => {
  const {
    state: { createdAt, updatedAt, completedAt },
    actions: { setCreatedAtDates, setUpdatedAtDates, setCompletedAtDates },
  } = usePhotoOrdersReportFilters();

  const [selectedFilter, setSelectedFilter] = useState('updatedAt');

  const handleDateChange = ({ startDate, endDate }) => {
    if (selectedFilter === 'createdAt') {
      setCreatedAtDates({ startDate, endDate });
      setUpdatedAtDates({ startDate: '', endDate: '' });
      setCompletedAtDates({ startDate: '', endDate: '' });
    } else if (selectedFilter === 'updatedAt') {
      setUpdatedAtDates({ startDate, endDate });
      setCreatedAtDates({ startDate: '', endDate: '' });
      setCompletedAtDates({ startDate: '', endDate: '' });
    } else if (selectedFilter === 'ingestionDate') {
      setCompletedAtDates({ startDate, endDate });
      setCreatedAtDates({ startDate: '', endDate: '' });
      setUpdatedAtDates({ startDate: '', endDate: '' });
    }
  };

  const getError = () => {
    if (selectedFilter === 'createdAt') {
      return createdAt.error;
    } else if (selectedFilter === 'updatedAt') {
      return updatedAt.error;
    } else if (selectedFilter === 'ingestionDate') {
      return completedAt.error;
    }
    return null;
  };

  React.useEffect(() => {
    handleDateChange({
      startDate: createdAt.startDate || updatedAt.startDate || completedAt.startDate,
      endDate: createdAt.endDate || updatedAt.endDate || completedAt.endDate,
    });
  }, [selectedFilter]);
  return (
    <React.Fragment>
      <DateRangeSelector
        onChange={handleDateChange}
        onClear={() => {
          setCreatedAtDates({ startDate: '', endDate: '' });
          setUpdatedAtDates({ startDate: '', endDate: '' });
          setCompletedAtDates({ startDate: '', endDate: '' });
        }}
        filterLabel={
          <select
            id="dateFilter"
            value={selectedFilter}
            onChange={(e) => setSelectedFilter(e.target.value)}
            style={{ margin: '0 10px', padding: '5px' }}
          >
            <option value="createdAt">Created At</option>
            <option value="updatedAt">Updated At</option>
            <option value="ingestionDate">Ingestion Date</option>
          </select>
        }
        keyName={selectedFilter}
        showApplyButton={false}
      />
      {getError() && <InlineMessage message={getError()} />}
    </React.Fragment>
  );
};

export default SingleDateRangeFilter;
